import { render, staticRenderFns } from "./SuiviFacturation.vue?vue&type=template&id=2268d602&"
import script from "./SuiviFacturation.vue?vue&type=script&lang=js&"
export * from "./SuiviFacturation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports